import { render, staticRenderFns } from "./btCrud.vue?vue&type=template&id=363c82bb"
import script from "./btCrud.vue?vue&type=script&lang=ts"
export * from "./btCrud.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports